<template>
  <div>
    <div v-show="!dialogVisibleLog">
      <STable
        ref="tableref"
        :url="url"
        :columns="columns"
        :handles="handles"
        :query="query"
        :selection="false"
        label-width="100px"
      />
    </div>

    <!-- <div v-show="dialogVisibleLog">
      <el-card shadow="never">
        <div slot="header">
          <span class="title">日志信息</span>
          <el-button type="primary" plain class="title-btn" @click="close">返回</el-button>
        </div>
        <el-form :inline="true" label-position="right" label-width="100px">
          <template v-for="(value,key,index) in logDetail"> -->
            <!-- 中文字段直接显示 -->
            <!-- <el-form-item v-if="!handleArray.includes(key)" :key="index" :label="key" class="width48">
              <div>{{ value||'--' }}</div>
            </el-form-item> -->
            <!-- 英文字段转换后再显示 -->
              <!-- <el-form-item v-else :key="index" :label="handleEnum(key)" class="width48">
                <div>{{ value||'--' }}</div>
              </el-form-item>
            </template>
            <el-form-item label="十六进制数据" class="width90">
              <div class="notWrap">{{ Data.Data||'--' }}</div>
            </el-form-item>
          </el-form>
        </el-card>
      </div> -->
  </div>
</template>

<script>
import { dataType } from '@/utils/interactive'
import { getYMDHMS } from '@/utils/date'
export default {
  data() {
    return {
      url: '/msglog/messageLog/page',
      dialogVisibleLog: false,
      logDetail: {}, // 详情字段数据
      // handleArray: ['msgType', 'sendType', 'time', 'Data'],
      Data: {}, // 详情十六进制字段
      // enum: {
      //   msgType: '类型',
      //   sendType: '发送类型',
      //   time: '时间',
      //   Data: '十六进制数据'
      // },
      query: [
        {
          label: '桩编码',
          prop: 'equipmentId',
          placeholder: '请输入桩编码'
        },
        {
          label: '枪编码',
          prop: 'connectorId',
          placeholder: '请输入枪编码'
        },
        {
          label: '交互数据类型',
          prop: 'exchangeType',
          type: 'select',
          data: dataType
        },
        {
          label: '开始时间',
          prop: 'time',
          placeholder: '请选择开始时间',
          type: 'date2',
          // haveValue: true,
          // option: {
          //   type: 'datetime'
          // },
          // data: this.getNowDayTime()[0]
        },
        // {
        //   label: '结束时间',
        //   prop: 'endTime',
        //   placeholder: '请选择结束时间',
        //   type: 'date',
        //   // haveValue: true,
        //   option: {
        //     type: 'datetime'
        //   },
        //   data: this.getNowDayTime()[1]
        // }
      ],
      columns: [
        {
          label: '桩编码',
          prop: 'equipmentId'
        },
        {
          label: '枪编码',
          prop: 'connectorId'
        },
        {
          label: '交互数据类型',
          prop: 'exchangeType',
          // template: function(index, reocrd) {
          //   let logData = logType.filter(item => {
          //     return item.value === reocrd.msgType
          //   })
          //   logData = logData.length === 0 ? [{ label: reocrd.msgType }] : logData
          //   return reocrd.msgType + '-' + logData[0].label
          // }
        },
        {
          label: '时间',
          prop: 'time',
          // template: (index, reocrd) => {
          //   return getYMDHMS(parseInt(reocrd.time))
          // }
        }
      ],
      handles: {
        width: 220,
        btns: [
          {
            label: '详情',
            permission: 'logCheck.electricPileMessageManagement.details',
            handle: resp => {
              // this.$router.push({ path: './historyDetail', query: { data: resp.id, num: resp.startChargeSeq }})


              // // 深拷贝防止影响原数据
              // const currentData = JSON.parse(JSON.stringify(resp))
              // // 时间戳转年月日时分秒
              // currentData.time = getYMDHMS(parseInt(currentData.time)) || ''
              // // 发送数据字段 1 2 转为 接收 发送
              // currentData.sendType = currentData.sendType === 1 ? '接收' : '发送'
              // const newMsgType = currentData.msgType
              // let logData = logType.filter(item => {
              //   return item.value === newMsgType
              // })
              // logData = logData.length === 0 ? [{ label: newMsgType }] : logData
              // currentData.msgType = newMsgType + '-' + logData[0].label
              // // 十六进制字段单独拿出来
              // this.$set(this.Data, 'Data', currentData.Data)
              // // 详情数据删除十六进制字段
              // delete currentData.Data
              // delete currentData.timeStr
              // // 整体详情数据赋值
              // this.logDetail = currentData
              // // 如果不为空则删除_id这个字段，这是没用的字段
              // this.logDetail && (delete this.logDetail._id)
              // // 打开弹窗
              // this.dialogVisibleLog = true
              this.$router.push({ path: './logDetail', query: { data: resp }})
            }
          }
        ]
      }
    }
  },
  methods: {
    /**
     * 详情英文字段转换
     */
    handleEnum(e) {
      return this.enum[e]
    },
    /**
     * 关闭弹窗
     */
    close() {
      this.dialogVisibleLog = false
    },
    // 获取当前月起止日期
    getNowDayTime() {
      const date = new Date().toLocaleDateString().split('/').map(item => { if (item < 10) { return '0' + item } else { return item } }).join('-')
      const arr = [date + ' 00:00:00', date + ' 23:59:59']
      return arr
    }
  }
}
</script>

<style scoped lang="less">
  .logDetailTxt{
    font-weight:600;
    color:#000;
    line-height: 10px;
  }
  .logDetailBox{
    background-color:#F2F2F2;
    padding: 20px;
  }
  .width48{
    width: 48%;
  }
  .width90{
    width: 90%;
    display: flex;
    /deep/.el-form-item__content{
      flex: 1;
    }
  }
  .notWrap{
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/LogManagement.vue